import { render, staticRenderFns } from "./ActiveClubs.vue?vue&type=template&id=6895fbb0&scoped=true&"
import script from "./ActiveClubs.vue?vue&type=script&lang=js&"
export * from "./ActiveClubs.vue?vue&type=script&lang=js&"
import style0 from "./ActiveClubs.vue?vue&type=style&index=0&id=6895fbb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6895fbb0",
  null
  
)

export default component.exports